import axios from 'axios';
import { IEventEmitter } from '@src/slide/infrastructure/module/independent/event-emitter/event-emitter.interface';
import { EventEmitter as EventBus } from '@src/slide/infrastructure/module/independent/event-emitter';
import {
    GET_CGI,
    SET_CGI,
    SYNC_CONFIG_MAP,
    SYNC_DESCRIPTION_MAP,
    SYNC_TYPE,
    TOGGLE,
} from '@src/slide/application/service/sync-file/core/constants';
import {
    IGetParams,
    ISetParams,
    IToggleOptions,
    ISyncFileToast,
    ISyncFileManager,
    SyncFileEventsMap,
} from '@src/slide/application/service/sync-file/core/sync-file-manager.interface';
import SyncFileToast from '@src/slide/application/service/sync-file/core/sync-file-toast';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';

export default class SyncFileManager implements ISyncFileManager {
    private static instance;

    public static getInstance(): SyncFileManager {
        if (!SyncFileManager.instance) {
            SyncFileManager.instance = new SyncFileManager();
        }
        return SyncFileManager.instance;
    }

    public toast: ISyncFileToast;
    public event: IEventEmitter<SyncFileEventsMap>;
    private currentType: SYNC_TYPE;

    public constructor() {
        this.currentType = SYNC_TYPE.NOT;
        this.event = new EventBus();
        this.toast = new SyncFileToast(this);
    }

    public updateSyncFileType = async (syncType: number): Promise<void> => {
        if (syncType === this.currentType) {
            return;
        }

        const options: IToggleOptions = {
            toggleOn: false,
            toggleScope: 0,
        };
        if (syncType === SYNC_TYPE.ALL) {
            options.toggleOn = true;
        } else if (syncType === SYNC_TYPE.CURRENT) {
            options.toggleOn = true;
            options.toggleScope = 1;
        }
        await this.setSyncAllFileFlag(options);
    };

    public getItemDescription = (): string => {
        const [syncConfigId] = Object.keys(SYNC_CONFIG_MAP)
            .filter(key => SYNC_CONFIG_MAP[key] === this.currentType);
        return SYNC_DESCRIPTION_MAP[syncConfigId];
    };

    public get currentSyncType(): SYNC_TYPE {
        return this.currentType;
    }

    public set currentSyncType(type: SYNC_TYPE) {
        this.currentType = type;
    }

    public getSyncAllFileFlag = async (): Promise<void> => {
        try {
            const params: IGetParams = {
                [TOGGLE.TOGGLE_TYPE]: 0,
                [TOGGLE.FILE_ID]: SlideDataServices.DocInfoManager()?.padId ?? '',
            };

            const { data } = await axios.post(GET_CGI, params);
            if (data.retcode === 0) {
                const { toggleOn, toggleScope } = data.result;
                this.setCurrentType(toggleOn, toggleScope);
            }
        } catch (e) {
            this.currentType = SYNC_TYPE.NOT;
            window.log.error(e);
        }
    };

    private setSyncAllFileFlag = async (options: IToggleOptions) => {
        const { toggleOn, toggleScope } = options;
        try {
            const params: ISetParams = {
                [TOGGLE.TOGGLE_TYPE]: 0,
                [TOGGLE.FILE_ID]: SlideDataServices.DocInfoManager()?.padId ?? '',
                [TOGGLE.TOGGLE_ON]: toggleOn,
                [TOGGLE.TOGGLE_SCOPE]: toggleScope,
            };

            const { data } = await axios.post(SET_CGI, params);
            if (data.retcode === 0 && data.msg === 'success') {
                this.setCurrentType(toggleOn, toggleScope);
            }
        } catch (e) {
            window.log.error(e);
        }
    };

    /**
     * 设置同步方式
     * toggleOn=false => 设置"不同步"
     * toggleOn=true && toggleScope=0 => 设置"同步全部"
     * toggleOn=true && toggleScope=1  => 设置"同步本篇"
     * @param toggleOn
     * @param toggleScope
     */
    private setCurrentType = (toggleOn: boolean, toggleScope: number): void => {
        if (toggleOn && toggleScope === 0) {
            this.currentType = SYNC_TYPE.ALL;
        } else if (toggleOn && toggleScope === 1) {
            this.currentType = SYNC_TYPE.CURRENT;
        } else {
            this.currentType = SYNC_TYPE.NOT;
        }
    };
}
